import { Box, DialogContent, Typography } from '@material-ui/core';
import React, { FC } from 'react';
import { UploadcareFile } from '../../types/uploadcare/file';
import { formatUploadcareImageForDisplay } from '../../util/uploadcare';
import DialogWithCloseButton from '../DialogWithCloseButton/DialogWithCloseButton';
import IconBackgroundRemoval from '../Icons/IconBackgroundRemoval/IconBackgroundRemoval';
import IconPencil from '../Icons/IconPencil/IconPencil';
import ResponsiveImage from '../ResponsiveImage/ResponsiveImage';

import css from './EditImageModal.module.css';

interface EditImageModalProps {
  open: boolean;
  image: UploadcareFile;
  onEditPhotoSelected: () => void;
  onClose: () => void;
  onBgRemoveSelected: () => void;
}

const EditImageModal: FC<EditImageModalProps> = (props: EditImageModalProps) => {
  const { open, image, onEditPhotoSelected: onEditPhoto, onBgRemoveSelected, onClose } = props;

  return (
    <DialogWithCloseButton open={open} onClose={onClose}>
      <DialogContent style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <Box p={3} maxWidth="400px">
          <ResponsiveImage
            className={css.imageContainer}
            alt={image.name}
            src={formatUploadcareImageForDisplay(image?.cdnUrl)}
          />
        </Box>
        <Box display="flex" justifyContent="space-around" mb={1}>
          <button type="button" className={css.modalButton} onClick={onEditPhoto}>
            <div className={css.iconContainer}>
              <IconPencil />
            </div>
            <Typography className={css.text} variant="body1">
              Crop, Rotate, Enhance
            </Typography>
          </button>
          <button type="button" className={css.modalButton} onClick={onBgRemoveSelected}>
            <div className={css.iconContainer}>
              <IconBackgroundRemoval />
            </div>
            <Typography className={css.text} variant="body1">
              Background Removal
            </Typography>
          </button>
        </Box>
      </DialogContent>
    </DialogWithCloseButton>
  );
};

export default EditImageModal;
